import { SyntheticEvent, useMemo } from 'react'
import styled from '@emotion/styled'
import OneTrip from './tsot'
import C50F from './c50f'
import C50I from './c50i'
import WristOx from './n3150'
import Nonin2500 from './n2500'
import Nonin8500 from './n8500'
import Respironics920MPlus from './920mp'
import Respironics920M from './n920m'
import Nonin7500 from './n7500'
import MasimoRAD8 from './rad8'
import CheckMeO2 from './checkmeo2'
import CheckMeO2Ppg from './checkmeo2-ppg'
import PC900B from './pc900b'

export interface IProps {
  onCancel: (e: SyntheticEvent) => void
  onConnect: (e: SyntheticEvent) => void
}

export type DeviceType =
  | 'tsot'
  | 'viatom'
  | 'c50f'
  | 'c50i'
  | 'n3150'
  | 'n2500'
  | 'n8500'
  | '920mp'
  | 'n920m'
  | 'n7500'
  | 'rad8'
  | 'rad97'
  | 'capnostream35'
  | 'n7500'
  | 'nlsii'
  | 'philips'
  | 'cadwell'
  | 'checkmeo2'
  | 'checkmeo2-ppg'
  | 'pc900b'

const types = {
  tsot: OneTrip,
  c50f: C50F,
  c50i: C50I,
  n3150: WristOx,
  n2500: Nonin2500,
  n8500: Nonin8500,
  '920mp': Respironics920MPlus,
  n920m: Respironics920M,
  n7500: Nonin7500,
  rad8: MasimoRAD8,
  checkmeo2: CheckMeO2,
  'checkmeo2-ppg': CheckMeO2Ppg,
  pc900b: PC900B,
}

const InstructionsWrapper = styled.div`
  margin-left: 0;
  .reader-view i, .reader-view .btn-default {
    margin-right: 0.5rem;
  }
  .reader-view ul {
    padding-left: 1rem;
  }
`

export const hasResetInstructions = (type: DeviceType): boolean => type in types

const Instructions = ({ type, ...props }: { type: DeviceType } & IProps) => {
  const Component = useMemo(() => types[type], [type])

  return (
    <InstructionsWrapper className="reader-view container flex flex-col justify-center items-center py-16 px-2 bg-blue-100 rounded-3xl">
      <Component {...props} />
    </InstructionsWrapper>
  )
}

export default Instructions
